$(document).ready(function () 
{
  wcFixedCart();
  wcFixedCartClick();  
  $('body').addClass('wc-fixed-cart');
  if( $('body').hasClass('wc-fixed-cart'))
  {
    throttledWcFixedCart();
  }
});

function throttle(func, delay) 
{
  let timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(() => {
        func.apply(this, arguments);
        timer = null;
      }, delay);
    }
  };
}

const throttledWcFixedCart = throttle(wcFixedCart, 100);

$(window).scroll(function () 
{
  throttledWcFixedCart();
});

function wcFixedCart() 
{
  const windowWidth = $(window).width();
  const isProductPage = $('body.template--product').length > 0;
  const addToCart = $('#add.pgroup-submit');
  const addToCartTemp = $('#add-to-cart-temp');
  const header = $('#shopify-section-header header');



  if (windowWidth < 768 && isProductPage && $('#add').length && addToCartTemp.length && header.length) 
  {
    let showAddToCartTemp = false;
    const viewTop = $(window).scrollTop();
    const swatches = $('.pgroup-swatches');
    const swatchesTop = swatches.offset().top;
    const swatchesBottom = swatchesTop + swatches.height();
    const headerHeight = header.outerHeight();
    

    if( $('body').hasClass('wc-fixed-cart'))
    {
      if(isElementInViewport('#add.pgroup-submit'))
      {
        showAddToCartTemp = false;
      }
      else
      {
        showAddToCartTemp = true;
      }
    }
    else
    {
      if (viewTop + headerHeight-50  > swatchesBottom)
      {
        showAddToCartTemp = true;
      }
      else
      {
        showAddToCartTemp = false;
      }  
    }


    if (showAddToCartTemp)
    {
      if ($('#add').is(':visible')) 
      {
        addToCartTemp.attr('style', $('#add').attr('style'));
      }
      addToCartTemp.show();
      //$("#gladlyChat_container").attr('style', 'display: none !important');
      
    }  
    else 
    {
      addToCartTemp.hide();
    //  $("#gladlyChat_container").attr('style', '');
      
    }
  }
}


function isElementInViewport(el) {
  const $el = $(el);
  const elementTop = $el.offset().top;
  const elementBottom = elementTop + $el.outerHeight();

  const viewportTop = $(window).scrollTop();
  const viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
}




function wcFixedCartClick() 
{
  if(!$('#add-to-cart-temp').length) 
  {
    $('body').append('<span id="add-to-cart-temp">Select Options</span>');
  }

  const windowWidth = $(window).width();
  const isProductPage = $("body.template--product").length > 0;
  const addToCartTemp = $('#add-to-cart-temp');
  const header = $('#shopify-section-header header');

  if (windowWidth < 768 && isProductPage && $("#add").length) 
  {
    addToCartTemp.click(function (e) 
    {
      e.preventDefault();
      const text = $(this).text().toLowerCase();

      if ( text.includes('add to cart') ) 
      {
        $("#add").click();
      } 
      else if (text === 'notify me when available') {
        $('.pgroup-bis').click();
      } 
      else 
      {
        if ($('.pgroup').length) 
        {
          const headerHeight = header.outerHeight() + 10;
          $('html,body').animate(
            { scrollTop: $('.pgroup').offset().top - headerHeight },
            'slow'
          );
        }
      }
    });

    const variantsChanged = $('#metafield-color-variants input[type=radio], .swatch.Length input[type=radio], .swatch.Size input[type=radio], .swatch.Cup input[type=radio]');

    variantsChanged.change(function (e) 
    {
      if ($('#add').is(':visible')) 
      {
        const text = $('#add').text().toLowerCase();
        if(text.includes('add to cart'))
          {
        addToCartTemp.html($('#add').html());
        }
        let style = $('#add').css('display');
        style = style.replace('block', '').trim();
        addToCartTemp.css('display', style);
      } 
      else 
      {
        addToCartTemp.text($('.pgroup-bis').text());
        addToCartTemp.css({ 'background-color': '#000', 'color': '#fff' });
      }
    });
  }
}
